import { useCallback } from 'react';

export const useNotification = () => {
  const play = useCallback(() => {
    if (typeof Notification === 'undefined') return;
    if (Notification.permission === 'granted') {
      new Notification('Pearlify', { body: 'Task finished!' });
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then((perm) => {
        if (perm === 'granted') new Notification('Pearlify', { body: 'Task finished!' });
      });
    }
  }, []);

  return { play };
};